import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import {
  WebContext,
  getPrivateApi,
  devConsolelog,
  isEmptyObject,
  queryStringToObj,
  formatDate2,
  getDomainValue,
  getPrefilledJson,
} from "../../Utility";
import {
  API_SECTION_LISTINGS,
  API_SECTION_OFFERS,
  API_ENDPOINT_ONLY_DESTINATION,
  API_DOMAIN_B2B2C,
  API_SECTION_B2B2C,
  API_ENDPOINT_WEBSITE_DATA,
  API_SECTION_PUBLIC,
  API_ENDPOINT_WEBSITE_GALLERY,
  B2B2C_API_PUBLIC_VERSION,
  API_ENDPOINT_WEBSITEPAGES,
  API_ENDPOINT_ES_SEARCH,
  API_SECTION_ACCOUNTS,
  API_ENDPOINT_CUSTOMER_FEEDBACK,
  API_ENDPOINT_FEATURED_DESTINATION,
  LOCAL_START,
} from "../../Constants";
import Default from "./Default";
import MySnackbar from "../Commons/mySnackbar";
import "./index.css";
import LoginSignUpModal from "./Login/loginSignUpModal";
import ChatBot from "./chat_bot_poc";
import LocalStorage from "../../LocalStorage";
import Auth from "../../Authenticate";
import moduleParser from "../../parser/modulerParser";
import AppThemeBaseLine from "../../AppTheme";

const DEFAULT_THEME_DATA = {
  primary_color: "#7c3647", //'#f18d03',
  secondary_color: "#212121",
  primary_text_color: "#ffffff", //'#f18d03',
  secondary_text_color: "#ffffff",
};

const INITIAL_THEME_DATA = {
  primary_color: "#ffffff", //'#7c3647',
  secondary_color: "#ffffff",
  primary_text_color: "#ffffff", //'#7c3647',
  secondary_text_color: "#ffffff",
};


const DEMO_LAYOUT_DATA = [
  {
    id: 1,
    name: "NAVBAR",
    position: 1,
    card_type: "NAVBAR_1",
    is_active: true,
    is_deleted: false,
    created_at: "2020-05-15T08:34:17.819660Z",
    updated_at: "2020-05-15T08:34:30.430478Z",
    website_data: 20,
    created_by: 1,
    updated_by: null,
    background_image: null,
  },
  {
    id: 2,
    name: "BANNER",
    position: 2,
    card_type: "BANNER_1",
    is_active: true,
    is_deleted: false,
    created_at: "2020-05-15T08:36:48.115600Z",
    updated_at: "2020-05-15T08:36:48.115620Z",
    website_data: 20,
    created_by: null,
    updated_by: null,
    background_image: null,
  },
  {
    id: 3,
    name: "BENEFITS",
    position: 4,
    card_type: "BENEFITS_1",
    is_active: true,
    is_deleted: false,
    created_at: "2020-05-15T08:36:48.116138Z",
    updated_at: "2020-05-15T08:36:48.116161Z",
    website_data: 20,
    created_by: null,
    updated_by: null,
    background_image: null,
  },
  {
    id: 4,
    name: "PRODUCTS",
    position: 4,
    card_type: "PRODUCTS_1",
    is_active: true,
    is_deleted: false,
    created_at: "2020-05-15T08:36:48.235115Z",
    updated_at: "2020-05-15T08:36:48.235145Z",
    website_data: 20,
    created_by: null,
    updated_by: null,
    background_image: null,
  },
  {
    id: 5,
    name: "TESTIMONIALS",
    position: 5,
    card_type: "TESTIMONIALS_1",
    is_active: true,
    is_deleted: false,
    created_at: "2020-05-15T08:37:43.347769Z",
    updated_at: "2020-05-15T08:37:43.347789Z",
    website_data: 20,
    created_by: null,
    updated_by: null,
    background_image: null,
  },
  {
    id: 6,
    name: "FOOTER",
    position: 6,
    card_type: "FOOTER_1",
    is_active: true,
    is_deleted: false,
    created_at: "2020-05-15T08:37:43.348302Z",
    updated_at: "2020-05-15T08:37:43.348321Z",
    website_data: 20,
    created_by: null,
    updated_by: null,
    background_image: null,
  },
];

const NAVBAR_COMPONENT_NAME = "NAVBAR";
const BANNER_COMPONENT_NAME = "BANNER";
const BENEFITS_COMPONENT_NAME = "BENEFITS";
const PRODUCTS_COMPONENT_NAME = "PRODUCTS";
const TESTIMONIALS_COMPONENT_NAME = "TESTIMONIALS";
const GALLERY_COMPONENT_NAME = "GALLERY";
const FOOTER_COMPONENT_NAME = "FOOTER";
const PRODUCTS_COLLECTION_COMPONENT_NAME = "PRODUCTSCOLLECTION";
const OFFERS_COMPONENT_NAME = "OFFERS";
const DESTINATIONS_COMPONENT_NAME = "DESTINATIONS";
const FEATURED_BLOG_COMPONENT_NAME = "FEATURED_BLOGS";
const FEATURED_OFFERS_COMPONENT_NAME = "FEATURED_OFFERS";
const SERVICES_COMPONENT_NAME = "SERVICES";
const BLOGS_COMPONENT_NAME = "BLOGS";
const PARTNERS_COMPONENT_NAME = "PARTNERS";

export default ({ children = null }) => {
  const isLoggedIn = Auth.isAuthenticated();
  const [memberProfile, setMemberProfile] = useState(
    LOCAL_START ? getPrefilledJson().TEMPLATE_DATA : {}
  );
  const [componentsOrder, setComponentsOrder] = useState(null);
  const [navbarTemplateType, setNavbarType] = useState(null);
  const [bannerTemplateType, setBannerType] = useState(null);
  const [benefitsTemplateType, setBenefitsType] = useState(null);
  const [productsTemplateType, setProductsType] = useState(null);
  const [offersTemplateType, setOffersType] = useState(null);
  const [destinationsTemplateType, setDestinationsType] = useState(null);
  const [featuredOffersTemplateType, setFeaturedOffersType] = useState(null);
  const [servicesTemplateType, setServicesType] = useState(null);
  const [blogsTemplateType, setBlogsType] = useState(null);
  const [featuredblogsTemplateType, featuredsetBlogsType] = useState(null);
  const [partnersTemplateType, setPartnersType] = useState(null);
  const [productsCollectionTemplateType, setProductsCollectionType] =
    useState(null);
  const [testimonialsTemplatesType, setTestimonialsType] = useState(null);
  const [galleryTemplateType, setGalleryTemplateType] = useState(null);
  const [footerTemplateType, setFooterType] = useState(null);
  const [memberCode, setMemberCode] = useState(null);
  const [lmsOrgCode, setLmsOrgCode] = useState(null);
  const [showDefault, setShowDefault] = useState(false);
  const [themeData, setThemeData] = useState(INITIAL_THEME_DATA);
  const [userType, setUserType] = useState("_domain_");
  const [seoData, setSeoData] = useState({});
  const [widgets, setWidgets] = useState([]);
  const [isV2Template, setIsV2Template] = useState(null);
  const { username = null } = useParams(); //"bhaskar.mamgai482728917"
  const [viewSnackbar, setViewSnackbar] = useState({
    message: null,
    type: null,
  });
  const [showLoginModal, setShowLoginModal] = useState({
    status: false,
    err: "",
  });
  const location = useLocation();
  let { memberProfileData = null } = location.state || {};
  const userData = LocalStorage.getUser();
  const {
    data: { auth_tokens = {} } = {},
    username: userProfileName = "",
    userCountryCode = "",
    userPhone = "",
    email = "",
  } = userData || {};
  const { access_token = "" } = auth_tokens || {};
  let history = useHistory();
  let {  account = {} } = memberProfile;
  let {
    lms_organisation_code = "",
  } = account;
  const { website_modules: websiteModules = {} } = memberProfile;
  const {
    flight: isFlightEnabled = false,
    news: isNewsEnabled = false,
    offers: isOffersEnabled = true,
    packages: isPackagesEnabled = true,
    pay_safely: isPaySafelyEnabled = true,
    destinations: isDestinationsEnabled = false,
    video_tours: isVideoToursEnabled = true,
    chatbot: isChatBotEnabled = true,
  } = websiteModules || {};

  const domainName = getDomainValue();
  const pageLocation = location.pathname;
  const [templateInfoData, setTemplateInfoData] = useState(
    LOCAL_START ? getPrefilledJson().HOME_PAGE_DATA : []
  );

  const isNotHomePageOrNewTemplate =
    pageLocation !== `/${username}` &&
    pageLocation !== `/${username}/` &&
    pageLocation !== `/` &&
    !isV2Template;

  const modules = moduleParser.moduleAccess(memberProfile);

  const packageRoute = modules?.packagesV2
    ? `/${username ? `${username}/` : ""}package/`
    : `/${username ? `${username}/` : ""}packages`;

  const hotelsAvailable = modules?.hotel;

  const NAVBAR_DATA = [
    {
      name: "Flights",
      id: "flight",
      link: `/${username ? `${username}/` : ""}flights`,
      isShow: isFlightEnabled,
    },
    {
      name: "Hotels",
      id: "hotels",
      link: `/${username ? `${username}/` : ""}hotelsearch/`,
      isShow: hotelsAvailable,
    },
    {
      name: "Packages",
      id: "package",
      link: packageRoute,
      isShow: modules?.canAccessPackages,
    },
    {
      name: "News",
      id: "news",
      link: `/${username ? `${username}/` : ""}news`,
      isShow: isNewsEnabled,
    },
    {
      name: "Video Tours",
      id: "videoTour",
      link: `/${username ? `${username}/` : ""}destination-guides/`,
      isShow: isVideoToursEnabled,
      isMandatory: true,
    },
    {
      name: "Pay Safely",
      id: "paySafely",
      link: `/${username ? `${username}/` : ""}pay`,
      isShow: isPaySafelyEnabled,
    },
    {
      name: "Know More",
      id: "knowMore",
      isDropdown: true,
      dropDownItem: [
        {
          name: "About Us",
          link: `/${username ? `${username}/` : ""}about`,
          reloadLink: true,
        },
        {
          name: "Contact Us",
          link: `/${username ? `${username}/` : ""}contact`,
        },
        {
          name: "Terms and conditions",
          link: `/${username ? `${username}/` : ""}pages/terms-and-conditions`,
          reloadLink: true,
        },
      ],
      isShow: true,
    },
    {
      name: `Login`,
      id: "login",
      isDropdown: true,
      link: ``,
      isBtn: true,
      isShow: true,
      dropDownItem: [
        {
          name: "My Bookings",
          id: "bookings",
          link: `/${username ? `${username}/` : ""}en/my_bookings`,
        },
        { name: "Logout", id: "logout", isBtn: true },
      ],
    },
  ];

  const [navbarData, setNavbarData] = useState(NAVBAR_DATA);

  useEffect(() => {
    if (!memberProfile || isEmptyObject(memberProfile)) return;
    let newNavbarArray = [];
    newNavbarArray = NAVBAR_DATA.filter((navbarItem) => {
      return navbarItem.isShow;
    });
    setNavbarData(newNavbarArray);
  }, [memberProfile]);

  const handleSearch = (searchVal = "") => {
    if (searchVal) {
      window.location = username
        ? `/${username}/packages/?&q=${searchVal}`
        : `/packages/?&q=${searchVal}`;
    }
  };

  let userUtilityFunctions = [
    {
      name: "handleSearchBar",
      handlerFunction: (searchVal) => {
        handleSearch(searchVal);
      },
    },
  ];

  const handleLogout = () => {
    window.localStorage.removeItem("b2b2cUser");
    history.push(`/${username ? `${username}/` : ""}`);
    window.location.reload();
  };

  let userProfileData = {
    userAccessToken: access_token,
    userName: userProfileName,
    userCountryCode: userCountryCode,
    userPhone: userPhone,
    email: email,
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    if (LOCAL_START) {
      handleSetMemberDataOnLoad(getPrefilledJson().TEMPLATE_DATA);
      return;
    }
    let queryString = "",
      userType = null,
      hostname = window.location.hostname;
    if (
      username &&
      (hostname.includes("mytripkart.in") ||
        hostname.includes("localhost") ||
        hostname.includes("dev.travclan.com"))
    ) {
      // use username flow
      queryString = `?organisation_code=${username}`;
      userType = "_username_";
    } else {
      // use domain flow
      queryString = `?domain_name=${getDomainValue(window.location.hostname)}`;
      userType = "_domain_";
    }
    setUserType(userType);
    if (memberProfileData && !isEmptyObject(memberProfileData)) {
      handleSetMemberDataOnLoad(memberProfileData);
    } else getProfile(queryString);
  }, []);

  useEffect(() => {
    if (isEmptyObject(memberProfile)) return;
    let { html_inject = [] } = memberProfile;
    setWidgets(html_inject.map((item) => item.is_active && item.html));
  }, [memberProfile]);

  const handleLayoutData = (apiData = []) => {
    let componentsOrder = {};
    apiData.forEach((item, index) => {
      componentsOrder[item.position.toString()] = item.name;
      handleComponentType(item);
    });
    setComponentsOrder(componentsOrder);
  };

  const handleComponentType = (item = null, data) => {
    if (!item) return;
    if (item.name == NAVBAR_COMPONENT_NAME) {
      if (item.card_type) setNavbarType(item);
    } else if (item.name == BANNER_COMPONENT_NAME) {
      if (item.card_type) setBannerType(item);
    } else if (item.name == BENEFITS_COMPONENT_NAME) {
      if (item.card_type) setBenefitsType(item);
    } else if (item.name == PRODUCTS_COMPONENT_NAME) {
      if (item.card_type) setProductsType(item);
    } else if (item.name == TESTIMONIALS_COMPONENT_NAME) {
      if (item.card_type) setTestimonialsType(item);
    } else if (item.name == GALLERY_COMPONENT_NAME) {
      if (item.card_type) setGalleryTemplateType(item);
    } else if (item.name == FOOTER_COMPONENT_NAME) {
      if (item.card_type) setFooterType(item);
    } else if (item.name == PRODUCTS_COLLECTION_COMPONENT_NAME) {
      if (item.card_type) setProductsCollectionType(item);
    } else if (item.name == OFFERS_COMPONENT_NAME) {
      if (item.card_type) setOffersType(item);
    } else if (item.name == DESTINATIONS_COMPONENT_NAME) {
      if (item.card_type) setDestinationsType(item);
    } else if (item.name == FEATURED_OFFERS_COMPONENT_NAME) {
      if (item.card_type) setFeaturedOffersType(item);
    } else if (item.name == SERVICES_COMPONENT_NAME) {
      if (item.card_type) setServicesType(item);
    } else if (item.name == BLOGS_COMPONENT_NAME) {
      if (item.card_type) setBlogsType(item);
    } else if (item.name == FEATURED_BLOG_COMPONENT_NAME) {
      if (item.card_type) featuredsetBlogsType(item);
    } else if (item.name == PARTNERS_COMPONENT_NAME) {
      if (item.card_type) setPartnersType(item);
    }
  };

  const handleSetMemberDataOnLoad = (data) => {
    if (data.website_cards && data.website_cards.length > 0)
      handleLayoutData(data.website_cards);
    else handleLayoutData(DEMO_LAYOUT_DATA);
    let {
      use_templates = false,
      website_template = {},
      leo_template = {},
    } = data;
    setMemberProfile(data);
    setMemberCode(data.lms_member_code);
    setLmsOrgCode(data?.account?.lms_organisation_code);
    handleSeoData(data);
    if (leo_template && !isEmptyObject(leo_template)) {
      setIsV2Template(Boolean(leo_template.template_name));
      setThemeData(leo_template);
    } else if (use_templates && website_template) {
      setThemeData(website_template);
      setIsV2Template(false);
    } else if (data.theme && data.theme.length > 0) {
      setThemeData(data.theme[0]);
      setIsV2Template(false);
    } else setThemeData(DEFAULT_THEME_DATA);
  };

  const handleSeoData = ({
    seo_data = [],
    default_seo_data = [],
    account = {},
  }) => {
    const company_name = account.company_name || "";
    const website_name = window.location.hostname || "";
    let temp_seo = {};
    if (seo_data && seo_data.length > 0) {
      temp_seo = { ...seo_data[0] };
    } else if (default_seo_data && default_seo_data.length > 0) {
      temp_seo = { ...default_seo_data[0] };
    }

    if (!isEmptyObject(temp_seo)) {
      temp_seo["title"] = `${company_name || website_name} : ${
        temp_seo["title"]
      }`;
      temp_seo["meta_keywords"] = `${company_name}, ${website_name}, ${
        temp_seo["meta_keywords"] || ""
      }`;
      temp_seo["meta_description"] = temp_seo["meta_description"]
        ? temp_seo["meta_description"]
            .replace("[domain name]", website_name)
            .replace("[company name]", company_name)
        : "";
    }
    setSeoData(temp_seo);
  };

  const getWhatsppPhone = (phone_numbers) => {
    let whatsappPhone = phone_numbers.find((item) => item.is_whatsapp === true);
    if (!whatsappPhone) whatsappPhone = phone_numbers[0].phone_no;
    else whatsappPhone = whatsappPhone.phone_no;
    return whatsappPhone;
  };

  const getProfile = async (queryString = "") => {
    let {
      data = null,
      err = null,
    } = await getPrivateApi(
      `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_WEBSITE_DATA}${queryString}`
    );

    if (err || !data) {
      setShowDefault(true);
      return;
    }
    if (data[0]) {
      handleSetMemberDataOnLoad(data[0]);
    }
  };

  const getAddress = (address = []) => {
    if (!address[0]) return "";
    let {
      city = "",
      line1 = "",
      line2 = "",
      state = "",
      pincode = "",
    } = address[0];
    return `${(line1 && line1) || ""} ${(line2 && line2) || "" } ${(city && `, ${city}`) || ""} ${
      (state && `, ${state}`) || ""
    } ${(pincode && `- ${pincode}`) || ""}`;
  };

  const handleTemplateData = (url = "", data = []) => {
    const newApiPart = url?.split("//")[1];
    const keyNameArray = newApiPart?.split("/") || [];
    const keyName = keyNameArray[keyNameArray.length - 2];
    const newObj = {};
    const isFeatured =
      keyNameArray[keyNameArray.length - 1]?.split("&")[1]?.split("=")[0] ===
        "featured" || false;

    if (keyName == "websitepages") {
      data.results = data?.results?.filter((blogs) => blogs.is_show == true);
      newObj[isFeatured ? "websitepagesFeatured" : keyName] = data?.results;
    } else if (keyName == "website-offers" && isFeatured) {
      newObj["website-offers-featured"] = data?.results;
    } else if (keyName == "customer-feedback") {
      const testimonials = data?.results.map((item) => {
        item.name = item.customer_name;
        item.text = item.comment;
        item.date = formatDate2(item.date_of_travel);
        return item;
      });
      newObj[keyName] = testimonials;
    } else if (keyName == "es-search") {
      const dataArray = { ...data };
      let { hits: { hits: results = [] } = {} } = dataArray;
      newObj[keyName] = results.filter((item) => item["_index"] !== ".kibana");
    } else {
      const { results = [] } = data;
      newObj[keyName] =
        data && !Array.isArray(data) && !isEmptyObject(data) && data.results
          ? results
          : data;
    }

    return newObj;
  };

  useEffect(() => {
    if (
      !domainName ||
      isNotHomePageOrNewTemplate ||
      isEmptyObject(memberProfile) ||
      !lms_organisation_code ||
      isV2Template === null
    )
      return;
    const galleryUrl = `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${API_SECTION_PUBLIC}${API_ENDPOINT_WEBSITE_GALLERY}?domain_name=${domainName}&page=1`;
    const testimonialsUrl = `${API_DOMAIN_B2B2C}${API_SECTION_ACCOUNTS}${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_CUSTOMER_FEEDBACK}?domain_name=${domainName}&is_show=true`;
    const offersUrl = `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${API_SECTION_PUBLIC}${API_SECTION_OFFERS}/?domain_name=${domainName}`;
    const featuredOffersUrl = `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${API_SECTION_PUBLIC}${API_SECTION_OFFERS}/?domain_name=${domainName}&featured=True`;
    const destinationUrl = `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${API_SECTION_PUBLIC}${API_ENDPOINT_ONLY_DESTINATION}?domain_name=${domainName}`;
    const featuredDestinationUrl = `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${API_SECTION_PUBLIC}${API_ENDPOINT_FEATURED_DESTINATION}?domain_name=${domainName}`;
    const articlesUrl = `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_WEBSITEPAGES}?domain_name=${domainName}`;
    const featuredArticlesUrl = `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_WEBSITEPAGES}?domain_name=${domainName}&featured=True`;
    const listingUrl = `${API_DOMAIN_B2B2C}${API_SECTION_LISTINGS}/${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_ES_SEARCH}?org_code=${lms_organisation_code}`;

    const promiseArr = [];
    promiseArr.push(getPrivateApi(galleryUrl));
    promiseArr.push(getPrivateApi(testimonialsUrl));

    if (isOffersEnabled) {
      promiseArr.push(getPrivateApi(offersUrl));
      promiseArr.push(getPrivateApi(featuredOffersUrl));
    }

    if (isDestinationsEnabled) {
      promiseArr.push(getPrivateApi(destinationUrl));
      promiseArr.push(getPrivateApi(featuredDestinationUrl));
    }

    promiseArr.push(getPrivateApi(articlesUrl));
    promiseArr.push(getPrivateApi(featuredArticlesUrl));

    if (isPackagesEnabled) {
      promiseArr.push(getPrivateApi(listingUrl));
    }

    if (LOCAL_START) {
      setTemplateInfoData(getPrefilledJson().HOME_PAGE_DATA);
    } else {
      Promise.all(promiseArr)
        .then((response) => {
          let resultsObj = {};
          response.forEach((item, index) => {
            const apiUrl = item?.config?.url;
            const { data = {} } = item || {};
            const currentObj = handleTemplateData(apiUrl, data);
            resultsObj = { ...resultsObj, ...currentObj };
          });
          setTemplateInfoData(resultsObj);
        })
        .catch((e) => {
          devConsolelog("api calls error", e);
        });
    }
  }, [
    isV2Template,
    domainName,
    memberProfile,
    lms_organisation_code,
    isOffersEnabled,
    isDestinationsEnabled,
    isPackagesEnabled,
  ]);

  let {
    "customer-feedback": testimonials = [],
    "website-gallery": gallery = [],
    "website-offers": offers = [],
    "website-offers-featured": featuredOffers = [],
    destinations: destination = [],
    "featured-destinations": featuredDestination = [],
    websitepages: articles = [],
    websitepagesFeatured: featuredArticles = [],
    "es-search": listing = [],
  } = templateInfoData || [];

  const deskTopView = useMediaQuery((theme) => theme.breakpoints.up("md"));
  
  const contextValue = {
    memberProfile,
    componentsOrder,
    navbarTemplateType,
    bannerTemplateType,
    benefitsTemplateType,
    productsTemplateType,
    productsCollectionTemplateType,
    testimonialsTemplatesType,
    galleryTemplateType,
    footerTemplateType,
    isMobile,
    isLoggedIn,
    showLoginModal,
    setShowLoginModal,
    memberCode,
    userType,
    username,
    getAddress,
    setViewSnackbar,
    userProfileData,
    getWhatsppPhone,
    userUtilityFunctions,
    searchParams: queryStringToObj(location.search) || {},
    themeData,
    getDomainValue,
    handleLogout,
    content_arr: navbarData,
    deskTopView,
    isV2Template: isV2Template,
    gallery: gallery,
    listingData: listing,
    destinations: destination,
    destinationsTemplateType,
    featuredDestination: featuredDestination,
    offers: offers,
    offersTemplateType,
    featuredOffers: featuredOffers,
    featuredOffersTemplateType,
    testimonials,
    articles: articles,
    featuredArticles: featuredArticles,
    lmsOrgCode,
    servicesTemplateType,
    blogsTemplateType,
    partnersTemplateType,
    featuredblogsTemplateType,
  };


  const { favicon_url = "" } = memberProfile || {};

  if (isEmptyObject(memberProfile) && !showDefault) return null;

  return (
    <>
      <WebContext.Provider value={contextValue}>
        <AppThemeBaseLine>
          <Helmet>
            <link
              preload
              href="https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap"
              rel="stylesheet"
            />
            {themeData.primary_font_family_cdn_link && (
              <link
                preload
                href={themeData.primary_font_family_cdn_link}
                rel="stylesheet"
              />
            )}
            {themeData.secondary_font_family_cdn_link && (
              <link
                preload
                href={themeData.secondary_font_family_cdn_link}
                rel="stylesheet"
              />
            )}
            <link
              rel="icon"
              type="image/png"
              href={favicon_url ? favicon_url : "/android-icon-96x96.png"}
            />
          </Helmet>
          {Boolean(viewSnackbar.message) && (
            <MySnackbar
              variant={viewSnackbar.type}
              message={viewSnackbar.message}
              setViewSnackbar={setViewSnackbar}
            />
          )}
          {showDefault ? <Default /> : children}
          {isChatBotEnabled && <ChatBot />}
          {showLoginModal["status"] && (
            <LoginSignUpModal
              onClose={() =>
                setShowLoginModal({ ...showLoginModal, status: false })
              }
            />
          )}
          {widgets && widgets.length > 0 && (
            <div id="widgets" className={"widgetsContainer"}></div>
          )}
        </AppThemeBaseLine>
      </WebContext.Provider>
    </>
  );
};
